import 'core-js'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
// import registerServiceWorker from './registerServiceWorker'
import qs from 'qs'

try {
  navigator.serviceWorker.getRegistrations()
  .then(function(registrations) {
      for(let registration of registrations) {  
          registration.unregister();
      }
  });
  console.log('卸载 serviceWorker')
} catch(err) {
  // console.error('serviceWorker');
}

let search = window.location.search.replace(/^\?/, '')
let query = qs.parse(search)
let token = query['xauth_ticket']
let invoker = query['invoker']

if (token) {
  localStorage.setItem('token', token)
}

ReactDOM.render(<App invoker={invoker}/>, document.getElementById('root'))
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js